import { Component, inject } from '@angular/core';

import { EditorTranslationsService } from '../../../services/editor-translations.service';

@Component({
  selector: 'empathy-translations-preview',
  templateUrl: 'translations-preview.component.html',
  styleUrls: ['./translations-preview.component.scss']
})
export class TranslationsPreviewComponent {
  translatationsService = inject(EditorTranslationsService);
}
